module.exports = __webpack_public_path__ + "img/teamwork4.34f9a4d0.jpeg";